<template>
    <transition name="modal-fade">
        <div class="modal-overlay" @click="$emit('close-modal')">
            <div class="modal-content hide-scrollbar" >
                <div class="preview-bg">
                    <div style="text-align:right; margin:8px 10px -10px 0px; z-index:999;"><span class="material-icons" @click="$emit('close-preview-modal')">close</span></div>
                    <div class="col-12 title text-center"> Contract Preview </div>
                </div>
               

                <iframe  id="iframe"/>

                <div class="col-12 preview-bg" style="text-align: right; margin-top: 20px;  padding: 0px 16px; ">
                    <div class="btn btn-negative" @click="$emit('close-preview-modal')" style="margin-right:8px;">Cancel</div>
                    <div class="btn btn-positive" @click="send">Send</div>
                </div>
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {
        data() {
            return {
                 
            }
        },
        methods: {
            iframeContent(data) {
                //replace data ;
                /*
                data = data.replace(/&[#\w]+;/g, function (s) {
                    var entityMap = {
                        "&amp;": "&",
                        "&lt;": "<",
                        "&gt;": ">",
                        '&quot;': '"',
                        '&#39;': "'",
                        '&#x2F;': "/",
                        "&nbsp;": " ",
                    };

                    return entityMap[s];
                });
                 */
                var doc = document.getElementById("iframe").contentWindow.document;
                doc.write(data);
                doc.close();
            },

            send() {
                this.$emit("send");
            }
        }
    }
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        z-index:999;
    }

    .modal-content {
        background-color: white;
        height: auto;
        width: 90%;
        max-height: 90vh;
        max-width: 930px;
        margin-top: 5%;
        overflow-x:hidden; 
       
    }
    iframe {
        width: calc(100% - 16px);
        height: 100%;
        margin: 8px;
    }
    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }
    .preview-bg {
        background-color: #71b18f;
    }
</style>